import { UseQueryResult, useQuery } from '@tanstack/react-query';

import { getTicketCheckIns } from '../queries/checkInTickets';
import { GetTicketCheckInsResponse } from '../types/queryTypes';

export function useGetAllCheckIns(
  checkInIds: string[] | null,
): UseQueryResult<GetTicketCheckInsResponse[], Error> {
  return useQuery({
    queryKey: ['ticketCheckIns', checkInIds],
    queryFn: () => {
      if (!checkInIds) throw new Error('Check-in ID is required');
      return getTicketCheckIns(checkInIds);
    },
    refetchOnWindowFocus: true,
    enabled: !!checkInIds,
  });
}
